import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the state type
interface AddressState {
  firstName: string;
  lastName: string;
  email: string;
  selectedCountry: string;
  city: string;
  address: string;
  zipCode: string;
  appartment: string;
}

// Define the payload type for the setAddress action
interface SetAddressPayload {
  field: keyof AddressState; // This ensures field is one of the keys in AddressState
  value: string;
}

const initialState: AddressState = {
  firstName: "",
  lastName: "",
  email: "",
  selectedCountry: "",
  appartment: "",
  city: "",
  address: "",
  zipCode: "",
};

const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    setAddressRedux: (state, action: PayloadAction<SetAddressPayload>) => {
      const { field, value } = action.payload;
      console.log("setAddressRedux triggered", field, value); // Log the action payload
      state[field] = value;
    },
    setFullAddress: (state, action: PayloadAction<AddressState>) => {
      console.log("setFullAddress triggered", action.payload); // Log the full address payload
      const {
        firstName,
        lastName,
        email,
        selectedCountry,
        appartment,
        city,
        address,
        zipCode,
      } = action.payload;
      state.firstName = firstName;
      state.lastName = lastName;
      state.email = email;
      state.selectedCountry = selectedCountry;
      state.appartment = appartment;
      state.city = city;
      state.address = address;
      state.zipCode = zipCode;
    },
  },
});

export const { setAddressRedux, setFullAddress } = addressSlice.actions;
export default addressSlice.reducer;
